export enum SubsidiariesActionTypes {
    GET_SUBSIDIARIES = "[App Action][Subsidiaries] GET SUBSIDIARIES",
    GET_SUBSIDIARIES_SUCCESS = "[App Action][Subsidiaries] GET SUBSIDIARIES SUCCESS",
    GET_SUBSIDIARIES_FAIL = "[App Action][Subsidiaries] GET SUBSIDIARIES FAIL",
    SAVE_SUBSIDIARY_LOGO = "[App Action][Subsidiaries] SAVE SUBSIDIARY LOGO",
    SAVE_SUBSIDIARY_LOGO_SUCCESS = "[App Action][Subsidiaries] SAVE SUBSIDIARY LOGO SUCCESS",
    SAVE_SUBSIDIARY_LOGO_FAIL = "[App Action][Subsidiaries] SAVE SUBSIDIARY LOGO FAIL",
    EDIT_SUBSIDIARY = "[App Action][Subsidiaries] EDIT SUBSIDIARY",
    EDIT_SUBSIDIARY_END = "[App Action][Subsidiaries] EDIT SUBSIDIARY END"
}
